import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_CATEGORY_FINANCE,
  CREATE_CATEGORY_FINANCE,
  DELETE_CATEGORY_FINANCE,
  UPDATE_CATEGORY_FINANCE,
  GET_CATEGORIES_FINANCE_SELECT,
  GET_CATEGORY_FINANCE_ORGANIZED,
} from './actionType';

import {
  CategoryFinanceApiResponseSuccess,
  CategoryFinanceApiResponseError,
} from './action';

import {
  getCategoryFinance as getFinanceCategory,
  createCategoryFinance as createFinanceCategory,
  updateCategoryFinance as updateFinanceCategory,
  deleteCategoryFinance as deleteFinanceCategory,
  getCategoriesFinanceSelect as getFinanceCategorySelect,
  getCategoryFinanceOrganized as getFinanceCategoryOrganized,
} from '../../helpers/backend_helper';

import { notifySuccess, notifyError } from '../../components/notify';

function* getCategoryFinance() {
  try {
    const response = yield call(getFinanceCategory);
    yield put(
      CategoryFinanceApiResponseSuccess(GET_CATEGORY_FINANCE, response)
    );
  } catch (error) {
    yield put(CategoryFinanceApiResponseError(GET_CATEGORY_FINANCE, error));
  }
}

function* getCategoryFinanceOrganized({ payload }) {
  try {
    const response = yield call(getFinanceCategoryOrganized, payload.type);
    yield put(
      CategoryFinanceApiResponseSuccess(
        GET_CATEGORY_FINANCE_ORGANIZED,
        response
      )
    );
  } catch (error) {
    yield put(
      CategoryFinanceApiResponseError(GET_CATEGORY_FINANCE_ORGANIZED, error)
    );
  }
}

function* createCategoryFinance({ payload }) {
  const { history, data } = payload;

  try {
    const response = yield call(createFinanceCategory, data);
    yield put(
      CategoryFinanceApiResponseSuccess(CREATE_CATEGORY_FINANCE, response)
    );
    notifySuccess('Categoria criada com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(CategoryFinanceApiResponseError(CREATE_CATEGORY_FINANCE, error));
    notifyError('Erro ao criar categoria!');
  }
}

function* updateCategoryFinance({ payload }) {
  const { history, data } = payload;

  try {
    const response = yield call(updateFinanceCategory, data);
    yield put(
      CategoryFinanceApiResponseSuccess(UPDATE_CATEGORY_FINANCE, response)
    );
    notifySuccess('Categoria atualizada com sucesso!');
    history.goBack();
  } catch (error) {
    yield put(CategoryFinanceApiResponseError(UPDATE_CATEGORY_FINANCE, error));
    notifyError('Erro ao atualizar categoria!');
  }
}

function* deleteCategoryFinance(data) {
  try {
    const response = yield call(deleteFinanceCategory, data.payload.id);
    yield put(
      CategoryFinanceApiResponseSuccess(DELETE_CATEGORY_FINANCE, response)
    );
    notifySuccess('Categoria deletada com sucesso!');
  } catch (error) {
    yield put(CategoryFinanceApiResponseError(DELETE_CATEGORY_FINANCE, error));
    notifyError('Erro ao deletar categoria!');
  }
}

function* getCategoryFinanceSelect(data) {
  try {
    const response = yield call(getFinanceCategorySelect, data.payload.type);
    yield put(
      CategoryFinanceApiResponseSuccess(GET_CATEGORIES_FINANCE_SELECT, response)
    );
  } catch (error) {
    yield put(
      CategoryFinanceApiResponseError(GET_CATEGORIES_FINANCE_SELECT, error)
    );
  }
}

export function* watchGetCategoryFinanceSelect() {
  yield takeEvery(GET_CATEGORIES_FINANCE_SELECT, getCategoryFinanceSelect);
}

export function* watchGetCategoryFinance() {
  yield takeEvery(GET_CATEGORY_FINANCE, getCategoryFinance);
}

export function* watchGetCategoryFinanceOrganized() {
  yield takeEvery(GET_CATEGORY_FINANCE_ORGANIZED, getCategoryFinanceOrganized);
}

export function* watchCreateCategoryFinance() {
  yield takeEvery(CREATE_CATEGORY_FINANCE, createCategoryFinance);
}

export function* watchUpdateCategoryFinance() {
  yield takeEvery(UPDATE_CATEGORY_FINANCE, updateCategoryFinance);
}

export function* watchDeleteCategoryFinance() {
  yield takeEvery(DELETE_CATEGORY_FINANCE, deleteCategoryFinance);
}

function* CategoryFinanceSaga() {
  yield all([fork(watchGetCategoryFinance)]);
  yield all([fork(watchGetCategoryFinanceOrganized)]);
  yield all([fork(watchCreateCategoryFinance)]);
  yield all([fork(watchUpdateCategoryFinance)]);
  yield all([fork(watchDeleteCategoryFinance)]);
  yield all([fork(watchGetCategoryFinanceSelect)]);
}

export default CategoryFinanceSaga;
